import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { ProblemSection } from '../components/ProblemSection';
import { FailedSolutions } from '../components/FailedSolutions';
import { MechanismSection } from '../components/MechanismSection';
import { WhatYouGet } from '../components/WhatYouGet';
import { WhoIsItFor } from '../components/WhoIsItFor';
import { HowItWorks } from '../components/HowItWorks';
import { FAQSection } from '../components/FAQSection';
import { OfferSection } from '../components/OfferSection';
import { FooterCTA } from '../components/FooterCTA';
export function LandingPage() {
  return <div className="min-h-screen bg-cream font-sans selection:bg-gold/30 selection:text-teal" data-id="element-167">
      <HeroSection data-id="element-168" />
      <ProblemSection data-id="element-169" />
      <FailedSolutions data-id="element-170" />
      <MechanismSection data-id="element-171" />
      <WhatYouGet data-id="element-172" />
      <WhoIsItFor data-id="element-173" />
      <HowItWorks data-id="element-174" />
      <FAQSection data-id="element-175" />
      <OfferSection data-id="element-176" />
      <FooterCTA data-id="element-177" />
    </div>;
}